<template>
  <div>
    <div class="background"></div>
    <div class="dialog">
      <div class="mainContent">
        <p class="close">
          <span class="closeButton" @click="onClose">✖</span>
        </p>
        <div class="title">新規登録</div>
        <p class="error">{{ errorMessage }}</p>
        <InputMailAddress @input="changeMailAddress" />
        <InputPassword @input="changePassword" />
        <ButtonTextLink
          class="button"
          :disable="!checkAll"
          @click-text="signup"
          text="新規登録"
        />
        <div class="bottom">
          <TextLink
            @click="onClickSignin"
            text="既にアカウントがある場合はこちらからログイン"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import InputMailAddress from "@/components/Input/InputMailAddress";
import InputPassword from "@/components/Input/InputPassword";
import TextLink from "@/components/Text/TextLink";
import Firebase from "./../../firebase";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "signup-modal",
  components: {
    InputMailAddress,
    InputPassword,
    TextLink,
    ButtonTextLink,
  },
  data() {
    return {
      mailadress: undefined,
      password: undefined,
      errorMessage: undefined,
      checkMaillAddress: false,
      checkPassword: false,
    };
  },
  computed: {
    checkAll() {
      return this.checkMaillAddress && this.checkPassword;
    },
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini", "setModal"]),
    changeMailAddress(value) {
      this.mailadress = value.value;
      this.checkMaillAddress = value.check;
    },
    changePassword(value) {
      this.password = value.value;
      this.checkPassword = value.check;
    },
    async signup() {
      if (!this.checkAll) return;
      this.loadingStartMini();
      let ok = false;
      await Firebase.createUser(this.mailadress, this.password)
        .then(() => {
          ok = true;
        })
        .catch((result) => {
          console.log("error", result);
          if (result.code === "auth/email-already-in-use") {
            this.errorMessage = "メールアドレスが利用済みです";
          } else if (result.code === "auth/argument-error") {
            this.errorMessage = "文字列が不正です";
          } else {
            this.errorMessage = "新規登録に失敗しました";
          }
        });

      if (!ok) {
        this.loadingEndMini();
        return;
      }
      await Firebase.getIsLoggednInWithFirebaseAuth();
      await Firebase.getRegistraion();
      if (location.pathname === "/branch") {
        this.$router.push({ name: "Settings" });
      }

      this.onClose();
      this.loadingEndMini();
    },
    onClickSignin() {
      this.setModal("signin");
    },
    onClose() {
      this.setModal("");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.mainContent {
  padding: 0 8px;
  .error {
    text-align: center;
    color: #ff7c86;
  }
}
.bottom {
  margin-top: 5vh;
  padding-top: 2vh;
}

.close {
  text-align: right;
  margin: 0;
  .closeButton {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}

.button {
  width: 70vw;
}

.title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: 80vw;
  padding: 1rem;
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/SignUpModal.vue